import { watchBorderPanelOverflow } from './blocks/border/overflow';

const overflowClassName = 'il-border-block__panel-content--has-overflow';

const initializeBorderPanels = () => {
    document
        .querySelectorAll('.il-border-block__panel-content')
        .forEach((panelContent) => {
            const scrollable = panelContent.querySelector('.il-border-block__panel-scrollable');

            watchBorderPanelOverflow(panelContent, scrollable, (hasOverflow) => {
                panelContent.classList.toggle(overflowClassName, hasOverflow);
            });
        });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBorderPanels, { once: true });
} else {
    initializeBorderPanels();
}